import { gql } from '@apollo/client';
import Fragments from './fragments';


export const FINANCIAL_PRODUCT_WARRANTY_QUERY = gql`
  query financialProductWarranty($leasingFinancialProductXWarrantyId: Int!) {
    financialProductWarranty(leasingFinancialProductXWarrantyId: $leasingFinancialProductXWarrantyId) {
        ...financialProductWarrantyEditItem
    }
  }
  ${Fragments.financialProductWarrantyEditItem}
`;

export const FINANCIAL_PRODUCT_WARRANTY_TYPES_QUERY = gql`
  query financialProductWarrantyTypeList {
    financialProductWarrantyTypeList {
        warrantyTypeId
        warrantyTypeName
    }
  }
`;

export const FINANCIAL_PRODUCT_WARRANTY_QUANTITY_TYPES_QUERY = gql`
  query financialProductWarrantyQuantityTypeList {
    financialProductWarrantyQuantityTypeList {
        quantityTypeId
        quantityTypeName
    }
  }
`;

